import { attachActivityToRoutine, getActivities, getUser, getUserRoutines } from "../api"
import { useState, useEffect } from "react";

export default function AttachActivity({token, routineId, activities, setActivities, setAttachActivity}) {
    const [activityId, setActivityId] = useState(0);
    const [count, setCount] = useState(0);
    const [duration, setDuration] = useState(0);

    const fetchActivities = async () => {
        try {
            const result = await getActivities();
            setActivities(result);
        } catch (err) {
            console.error("Failed to fetch activities", err);
        }   
    };

    const gettingUserAndRoutines = async () => {
        try {
            const userResult = await getUser(token);
            setUser(userResult.username);
            const userRoutinesResult = await getUserRoutines(userResult.username);
            setUserRoutines(userRoutinesResult);
        } catch (err) {
            console.error("Failed to fetch user data or user routines", err);
        }     
    };

    useEffect(() => {
        fetchActivities();
    }, []);

    return (
        <form className="makeRoutine" onSubmit={(event) => {
            event.preventDefault();
            attachActivityToRoutine(routineId, activityId, count, duration);
            setAttachActivity(false);
            gettingUserAndRoutines();
        }}>
            <h2>Attach Activity</h2>
            <div className="form-element">
                <label htmlFor="attach-activity">Activity</label>
                <select name="activity" id="activity" value={activityId} required onChange={(event) => {setActivityId(event.target.value)}}>
                    {
                        activities.map((activity) => {
                            return <option key={activity.id} value={activity.id}>{activity.name}</option>
                        })
                    }
                </select>
            </div>
            <div className="form-element">
                <label htmlFor="create-count">Count</label>
                <input id="create-count" type="number" value={count} required onChange={event => {setCount(event.target.value)}}></input>
            </div>
            <div className="form-element">
                <label htmlFor="create-duration">Duration</label>
                <input id="create-duration" type="number" value={duration} required onChange={event => {setDuration(event.target.value)}}></input>
            </div>
            <div className="buttonContainer">
                <button type="submit" className="small-form-button">Submit</button>
                <button className="small-form-button" onClick={()=> {setAttachActivity(false)}}>Cancel</button>
            </div>
        </form>
    )
}